<div class="info-box">
  <app-icon iconName="info" iconClassName="icon icon--extra-small icon--no-margin" class="info-box__icon"></app-icon>
  <p [innerHTML]="message"></p>
</div>
